<div class="py-2">
  <tui-island
    class="bg-neutral-100"
    (tuiActiveZoneChange)="zoneChanged$.next($event)"
  >
    <h2 class="font-semibold mb-4">Перевозчик</h2>
    <div class="flex w-full">
      <app-autocomplete
        tuiDropdownContext
        #carrierJsonDropdown="tuiDropdown"
        [tuiDropdown]="carrierJsonContext"
        class="w-3/12"
        label="Перевозчик"
        [labelOutside]="false"
        [items]="catalogs.carriers$ | async"
        [itemText]="'name'"
        [itemValue]="'id'"
        [displayValue]="'name'"
        [itemSearch]="'search'"
        [formControl]="carrierForm.controls.id"
      ></app-autocomplete>
      <ng-template #carrierJsonContext>
        <tui-data-list role="menu" tuiDataListDropdownManager>
          <button
            (click)="
              openCarrierDialog$.next('create');
              carrierJsonDropdown.toggle(false)
            "
            tuiOption
          >
            Добавить перевозчика в каталог
          </button>
          <button
            [disabled]="!carrierForm.controls.id.value"
            (click)="
              openCarrierDialog$.next('edit'); carrierJsonDropdown.toggle(false)
            "
            tuiOption
          >
            Редактировать перевозчика
          </button>
        </tui-data-list>
      </ng-template>

      <div class="flex mr-0 ml-auto gap-x-2 w-6/12 justify-end">
        <tui-input-number
          [formControl]="carrierForm.controls.cost"
          class="w-4/12"
          tuiTextfieldSize="m"
          >Ставка перевозчику</tui-input-number
        >
        <app-autocomplete
          class="w-2/12"
          label="Валюта"
          [labelOutside]="false"
          [itemValue]="'letterCode'"
          [itemText]="'name'"
          [items]="CURRENCIES"
          [formControl]="carrierForm.controls.currencyLetter"
        ></app-autocomplete>
        <app-autocomplete
          class="w-4/12"
          label="Вид оплаты"
          [labelOutside]="false"
          [itemValue]="'value'"
          [itemText]="'name'"
          [displayValue]="'name'"
          [items]="PAYMENT_TYPES"
          [formControl]="carrierForm.controls.paymentType"
        ></app-autocomplete>
      </div>
    </div>

    <div class="my-2">
      @for (
        transport of carrierForm.controls.transports.controls;
        track transport.controls.guid.value
      ) {
        <app-transport-item-form
          (attach)="
            openAttachmentsDialog$.next({
              attachmentId: transport.controls.attachmentId.getRawValue(),
              index: $index
            })
          "
          (remove)="removeTransport($index)"
          [canRemove]="!(cargoLoadingService.readonly$ | async)!"
          [transportForm]="transport"
        ></app-transport-item-form>
      }
      <button
        [disabled]="(cargoLoadingService.readonly$ | async)!"
        class="my-2"
        (click)="addTransport()"
        size="s"
        appearance="primary"
        tuiButton
        icon="tuiIconPlus"
      >
        Добавить транспорт
      </button>
    </div>

    <div>
      <h2 class="font-semibold mb-4">Дополнительные расходы</h2>
      @for (
        payment of carrierForm.controls.additionalPayments.controls;
        track $index
      ) {
        <div class="flex gap-x-2 items-center mb-2">
          <tui-input
            class="w-6/12"
            [formControl]="payment.controls.comment"
            tuiTextfieldSize="m"
            >Комментарий</tui-input
          >
          <tui-input-number
            class="w-2/12"
            [precision]="2"
            [formControl]="payment.controls.sum"
            tuiTextfieldSize="m"
            >Сумма</tui-input-number
          >
          <app-autocomplete
            label="Валюта"
            class="w-1/12"
            [labelOutside]="false"
            [formControl]="payment.controls.currencyLetter"
            [itemValue]="'letterCode'"
            [itemText]="'name'"
            [items]="CURRENCIES"
          ></app-autocomplete>
          <button
            [disabled]="(cargoLoadingService.readonly$ | async)!"
            tuiIconButton
            icon="tuiIconTrash"
            appearance="accent"
            size="s"
            (click)="removeAdditionalPayment($index)"
          ></button>
          @if ($last) {
            <button
              [disabled]="(cargoLoadingService.readonly$ | async)!"
              tuiIconButton
              icon="tuiIconPlus"
              size="s"
              (click)="addAdditionalPayment()"
            ></button>
          }
        </div>
      } @empty {
        <button
          [disabled]="(cargoLoadingService.readonly$ | async)!"
          (click)="addAdditionalPayment()"
          tuiButton
          icon="tuiIconPlus"
          size="s"
        >
          Добавить
        </button>
      }
    </div>
  </tui-island>
</div>
